// extracted by mini-css-extract-plugin
export default {"cls1":"hRcjgZoYflpYLzL93Ast","cls2":"IAWJZjibOZTXmMLqiSX9 hRcjgZoYflpYLzL93Ast"};